import React from 'react'
import { ThemeContext } from './index'

const themeDefault = 'aurum'
const pageDefault = ''

const ThemeContextProvider = ({
	children,
	value = themeDefault,
	page = pageDefault,
}) => {
	return (
		<ThemeContext.Provider value={{ theme: value, page }}>
			{children}
		</ThemeContext.Provider>
	)
}

export default ThemeContextProvider
